module.exports = __webpack_public_path__ + "static/media/thumbnail-fallback.0c76ce10.png";